import React, { useEffect } from 'react';
import { ListPagination } from '@redpanda/ui';
import { useTranslation } from 'react-i18next';
import { RecentActivity } from '@redpanda/types';
import { useActivityStore, ACTIVITIES_PER_PAGE } from '../stores/activityStore';
import ActivityItem from '../components/ActivityItem';

const ActivityPage: React.FC = () => {
  const { t } = useTranslation();
  const {
    activities,
    loading,
    error,
    currentPage,
    totalPages,
    total,
    fetchActivities,
    setCurrentPage
  } = useActivityStore();

  // fetchActivities 內部會自動嘗試從儀表板同步最新資料
  useEffect(() => {
    fetchActivities(currentPage);
  }, [fetchActivities, currentPage]);

  const pagination = { currentPage, totalPages, totalItems: total, pageSize: ACTIVITIES_PER_PAGE };

  if (loading) {
    return (
      <div className="container mx-auto px-10 py-6 pb-32">
        <div className="text-center">
          <p className="text-fg-secondary">{t('common.status.loading')}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-10 py-6 pb-32">
        <div className="text-center text-red-500">{error}</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-10 py-6 pb-32">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">{t('activities.title', { ns: 'pages' })}</h1>
      </div>

      {/* 表格上方的分頁控制 */}
      <ListPagination pagination={pagination} onPageChange={setCurrentPage} className="mb-3" />

      {/* 單一容器＋細線分隔（R13） */}
      <div className="bg-surface rounded-lg border border-line overflow-hidden">
        <ul className="divide-y divide-line">
          {activities && activities.length > 0 ? (
            activities.map((activity: RecentActivity) => (
              <ActivityItem key={`${activity.type}-${activity.id}`} activity={activity} />
            ))
          ) : (
            <li className="px-5 py-8 text-center text-fg-secondary">
              {t('activities.noActivities', { ns: 'pages' })}
            </li>
          )}
        </ul>
      </div>

      {/* 表格下方的分頁控制 */}
      <ListPagination pagination={pagination} onPageChange={setCurrentPage} className="mt-6" />
    </div>
  );
};

export default ActivityPage;